<section class="banner" aria-labelledby="banner-title">
  <div class="banner__inner">
    <div class="banner__content">
      <p class="banner__badge">
        <svg class="banner__badge-icon" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 2.5 4.5 5.2v6.1c0 4.6 3.2 8.9 7.5 10.2 4.3-1.3 7.5-5.6 7.5-10.2V5.2L12 2.5Z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          />
          <path
            d="m8.8 12.1 2.1 2.1 4.3-4.4"
            fill="none"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Benchmarking platform (BODH)
      </p>

      <h1 id="banner-title" class="banner__title">
        Benchmarking Open Data Platform for Health AI (BODH)
      </h1>

      <p class="banner__subtitle">
        Evaluate your AI models against trusted Indian clinical datasets without exposing your model or the benchmarking data.
      </p>

      <div class="banner__actions">
        <a class="banner__btn banner__btn--primary" routerLink="/reference">
          Explore benchmarking datasets
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path
              d="M8.79 2.29a1 1 0 0 1 1.42 0l4.5 4.5a1 1 0 0 1 0 1.42l-4.5 4.5a1 1 0 0 1-1.42-1.42L11.09 9H2a1 1 0 0 1 0-2h9.09L8.79 3.71a1 1 0 0 1 0-1.42Z"
              fill="currentColor"
            />
          </svg>
        </a>
        <a
          class="banner__btn banner__btn--secondary"
          href="#secure-flow"
          (click)="scrollToSecureFlow($event)"
        >
          How secure evaluation works
        </a>
      </div>

      <div class="banner__partners">
        <div class="banner__collab">
        <p class="banner__collab-label">In collaboration with</p>
        <div class="banner__logos">
          <span class="banner__logo-slot banner__logo-slot--iisc">
            <img
              class="banner__logo banner__logo--iisc"
              src="/landing/iisc-collab-logo.png"
              alt="Indian Institute of Science"
              width="102"
              height="76"
            />
          </span>
          <span class="banner__logo-slot banner__logo-slot--iitk">
            <img
              class="banner__logo banner__logo--iitk"
              src="/landing/iit-kanpur-logo.png"
              alt="Indian Institute of Technology Kanpur"
              width="72"
              height="72"
            />
          </span>
          <span class="banner__logo-slot banner__logo-slot--dpg">
            <img
              class="banner__logo banner__logo--dpg"
              src="/cdpg.svg"
              alt="Data for Public Good"
              width="168"
              height="43"
            />
          </span>
        </div>
        </div>
      </div>
    </div>

    <div class="banner__visual" aria-hidden="true">
      <img
        class="banner__illustration"
        src="/landing/banner-cube.jpg"
        alt=""
      />
    </div>
  </div>
</section>
